module.exports = __webpack_public_path__ + "static/img/jiaotong-2.b1447a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiaotong/jiaotong-2.png
// module id = elPR
// module chunks = 1